import BigNumber from 'bignumber.js';

import { CurrencyEnum } from 'app/components/ui/CurrencySwitcher/CurrencySwitcher';

import {
  CLOUDFLARE_IPFS,
  DEFAULT_DECIMALS, IPFS, IPFS_IO, TEMPLEWALLET_IMG,
} from './defaults';

export const shortize = (str: string, amount?: number) => str && `${str.slice(0, amount ?? 7)}...${str.slice(-4)}`;

export const getSlice = (str: string) => (str.length > 8 ? `${str.substr(0, 6)}...` : str);

export const getUniqueKey = () => Math.round(Math.random() * 10000000000000);

export const transformMutezToTez = ({
  value,
  fraction,
  dec = DEFAULT_DECIMALS,
  currency = CurrencyEnum.XTZ,
  xtzUsdQuote = 0,
}: {
  value: any;
  fraction?: any;
  dec?: number;
  currency?: CurrencyEnum;
  xtzUsdQuote?: number;
}) => {
  const getFormatter = () => {
    if (value.toString().length > 6) {
      return new Intl.NumberFormat(
        'en',
        {
          maximumFractionDigits: fraction ?? 6,
          notation: 'compact',
        },
      );
    }

    return new Intl.NumberFormat(
      'en',
      {
        maximumFractionDigits: fraction ?? 6,
      },
    );
  };

  const transformValue = new BigNumber(value).div(10 ** dec);

  if (currency === CurrencyEnum.USD) {
    return getFormatter().format(+transformValue.multipliedBy(xtzUsdQuote));
  }

  return getFormatter().format(+transformValue);
};

export const prettyPrice = (value: number, dec?: number) => {
  if (value.toString().length > 6) {
    return new Intl.NumberFormat(
      'en',
      {
        maximumFractionDigits: dec ?? 6,
        notation: 'compact',
      },
    ).format(value);
  }

  return new Intl.NumberFormat(
    'en',
  ).format(value);
};

export const switchCurrency = ({
  value,
  xtzUsdQuote,
  currency = CurrencyEnum.XTZ,
}: {
  value: number;
  xtzUsdQuote: number;
  currency?: CurrencyEnum;
}) => {
  if (currency === CurrencyEnum.USD) {
    return prettyPrice(value * xtzUsdQuote);
  }

  return prettyPrice(value);
};

export const getTokenLogo = (url: string | null) => {
  if (!url?.trim()) {
    return null;
  }

  const trimUrl = url.trim();

  const splitLink = trimUrl.split('://');
  const getProtocol: string = splitLink && splitLink.length ? splitLink[0] : '';
  const isIpfs = getProtocol === IPFS;

  if (isIpfs) {
    return `${TEMPLEWALLET_IMG}/${IPFS_IO}${splitLink[1]}`;
  }

  if (trimUrl.match(/\.(jpeg|jpg|gif|png)$/) !== null
  || trimUrl.includes(CLOUDFLARE_IPFS)
  || trimUrl.includes(IPFS_IO)) {
    return `${TEMPLEWALLET_IMG}/${trimUrl}`;
  }

  return null;
};
